<template>
    <div class="annotation-list">
        <annotation-edit v-for="annotation in annotations" :key="annotation.getId()" :annotation="annotation"/>
    </div>
</template>

<script>
import AnnotationEdit from "@/modules/annotation/annotation-edit";
export default {
    name: "annotation-list",
    components: {AnnotationEdit},
    props:{
        annotations:{type:Array,default: () => []}
    },
}
</script>